// #710 — 12hr vs 24hr display preference for the standby screen's wall clock
// and scheduled-time labels.
//
// Same shape as the other scribe-local stores (sheetFieldOrder.js,
// manualRides.js, signatureStore.js): a namespaced STORAGE_KEY plus
// try/catch'd get/set, so a browser with storage disabled (private mode)
// degrades to the default rather than throwing. Deliberately NOT on the
// user/account record — scribe-fe is an offline-first PWA and this is a
// personal display habit, not sheet data.

const STORAGE_KEY = "scribe-fe.timeFormat";

export const HOUR_12 = "12h";
export const HOUR_24 = "24h";

const VALID = [HOUR_12, HOUR_24];

/** @returns {string} HOUR_12 (default) or HOUR_24. */
export function getTimeFormat() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    // Unset, or junk written by a future/older build — fall back to the
    // spec default (12hr, per #710) rather than handing callers a value
    // they can't read.
    return VALID.includes(raw) ? raw : HOUR_12;
  } catch {
    return HOUR_12;
  }
}

/** @param {string} format - HOUR_12 or HOUR_24; anything else is ignored. */
export function setTimeFormat(format) {
  if (!VALID.includes(format)) return;
  try {
    localStorage.setItem(STORAGE_KEY, format);
  } catch {
    // Storage unavailable (private browsing) — non-fatal; the setting just
    // won't survive the reload.
  }
}
